/**
 * Точка
 * @memberof module:math
 */
class Vector {

    /**
     * @constructor
     * @param {Number} x координата
     * @param {Number} y координата
     */
    constructor(x = 0, y = 0) {
        /**
         * @member {Number} module:math.Vector~x координата x
         */
        this.x = x;

        /**
         * @member {Number} module:math.Vector~y координата y
         */
        this.y = y;
    }

    /**
     * Проверка на нулевые значения x и y
     */
    isZero() {
        return this.x == 0 && this.y == 0;
    }

    /**
     * Клонирование точки
     * @returns {module:math.Vector} копия точки
     */
    clone() {
        return new Vector(this.x, this.y);
    }

    /**
     * Сложение точек
     * @param {module:math.Vector} p точка
     */
    add(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    }

    /**
     * Вычитание точек
     * @param {module:math.Vector} p точка
     */
    subtract(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    }

    /**
     * Скалярное умножение
     * @param {Number} n число
     */
    mult(n) {
        this.x *= n;
        this.y *= n;
        return this;
    }

    /**
     * Инвертирование
     */
    invert() {
        this.mult(-1);
        return this;
    }

    /**
     * Поворот точки
     * @param {Number} angle угол поворота
     * @param {module:math.Vector} offset смещение
     */
    rotate(angle, offset = new Vector(0, 0)) {
        var r = this.clone();
        r.subtract(offset);
        r.x = this.x * Math.cos(angle) + this.y * Math.sin(angle);
        r.y = this.x * -Math.sin(angle) + this.y * Math.cos(angle);
        r.add(offset);
        this.x = r.x;
        this.y = r.y;
        return this;
    }

    /**
     * Нормализация точки
     * @param {Number} angle угол поворота
     * @param {module:math.Vector} offset смещение
     */
    normalize(angle, offset = new Vector(0, 0)) {
        this.subtract(offset);
        this.rotate(-angle);
        return this;
    }

    /**
     * Возвращает скалярную длину вектора
     * @returns {Number} длина вектора
     */
    getLength() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }

    /**
     * Вычисление расстояния до другой точки
     * @param {module:math.Vector} p точка
     */
    distanceTo(p) {
        var p2 = this.clone();
        p2.subtract(p);
        return p2.getLength();
    }
}

export {Vector};